export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const emailFieldRules = {
  required: 'Email is required',
  pattern: {
    value: EMAIL_PATTERN,
    message: 'Please enter a valid email address',
  },
} as const;

export const PASSWORD_REUSED_MESSAGE =
  'Password cannot be the same as any of your last 5 passwords.';

export const passwordFieldRules = {
  minLength: {
    value: 8,
    message: 'Password must be at least 8 characters',
  },
  maxLength: {
    value: 20,
    message: 'Password must be at most 20 characters',
  },
  validate: {
    uppercase: (value: string) =>
      /[A-Z]/.test(value) || 'Must contain an uppercase letter',
    lowercase: (value: string) =>
      /[a-z]/.test(value) || 'Must contain a lowercase letter',
    number: (value: string) => /[0-9]/.test(value) || 'Must contain a number',
    special: (value: string) =>
      /[\W_]/.test(value) || 'Must contain a special character',
  },
} as const;

export const requiredPasswordRule = {
  required: 'Password is required',
} as const;

export function confirmPasswordRules(getPassword: () => string) {
  return {
    required: 'Please confirm your password',
    validate: (value: string) =>
      value === getPassword() || 'Passwords do not match',
  };
}
